import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"content"},_vm._l((_vm.details),function(item){return _c(VRow,{key:item.company},[_c(VCol,{attrs:{"cols":"9"}},[_vm._v(_vm._s(item.company !== "zzz" ? item.company : "Other"))]),_c(VCol,{staticClass:"text-right",attrs:{"cols":"3"}},[_vm._v(_vm._s(item.times)+" time(s)")])],1)}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }